import KeyedAndNamedDto from 'modules/base/dto/KeyedAndNamedDto';
import FmStoragePermissionDto from './FmStoragePermissionEditDto';

export class FmStorageEditDto extends KeyedAndNamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.fileName = null;
		/** @type {Array<FmStoragePermissionDto>} */
		this.permissionList = null;
	}

	/**
	 * @typedef {Object} _FmStorageEditDtoProps
	 * @property {string} fileName
	 * @property {Array<FmStoragePermissionDto} permissionList
	 * @typedef {import("../KeyedAndNamedDto").KeyedAndNamedDtoProps & _FmStorageEditDtoProps} FmStorageEditDtoProps
	 */
	/**
	 *
	 * @param {FmStorageEditDtoProps} props
	 * @returns {FmStorageEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.fileName = props.fileName;
		this.permissionList = props.permissionList != null ? props.permissionList.map(d => new FmStoragePermissionDto().setup(d)) : [];
		return this;
	}
}

export default FmStorageEditDto;
